// Mémoire technique — contrat de l'API (server/modules/memoire/routes.ts) et libellés partagés par les écrans.

export type FormatMemoire = 'note' | 'memoire' | 'cadre';
export type StatutMemoire = 'brouillon' | 'relu' | 'emis';

export interface SourceBloc { type: string; ref: string; libelle: string }
export interface Bloc {
  id: string; type: 'titre' | 'paragraphe' | 'liste' | 'tableau' | 'a_completer' | 'avertissement' | 'illustration';
  niveau: 2 | 3 | null; texte: string; items: string[]; colonnes: string[]; lignes: string[][]; champ: string | null;
  origine: string; sources: SourceBloc[]; verrouille: boolean; modifie: boolean; interne: boolean; empreinte: string;
  [k: string]: unknown;
}
export interface SectionMemoire {
  id: string; numero: number; titre: string; statut_ia: 'oui' | 'assistee' | 'non'; reformulable: boolean; incluse: boolean;
  raison_exclusion: string | null; complete: 'vide' | 'partielle' | 'complete'; relue: boolean; erreur: string | null; blocs: Bloc[];
  [k: string]: unknown;
}
export interface ContenuMemoire { titre: string; sections: SectionMemoire[]; ia: { utilisee: boolean; sections: string[] }; [k: string]: unknown }

export interface VueMemoire {
  id: string; dossier_id: string; numero: string | null; statut: StatutMemoire; version_no: number; format: FormatMemoire; version: number;
  choix: { sections: string[]; format: FormatMemoire }; saisie: Record<string, any>; contenu: ContenuMemoire; contient_ia: boolean;
  reformulations: number; version_document: 'travail' | 'definitive' | null;
  relu: { par: string; le: string } | null; emis: { par: string; le: string } | null;
  manques: { section: string; texte: string }[]; pages_estimees: number; engagement: string;
  precedent: { id: string; numero: string | null; version_no: number } | null;
  suivant: { id: string; numero: string | null; version_no: number; statut: StatutMemoire } | null;
  demo: boolean; dossier_reference: string;
}

export interface MemoireListe {
  id: string; numero: string | null; statut: StatutMemoire; version_no: number; format: FormatMemoire;
  version_document: 'travail' | 'definitive' | null; contient_ia: boolean; cree_le: string; modifie_le: string; emis_le: string | null; precedent_id: string | null;
}

export interface AlerteFiche { code: string; gravite: string; message: string; rubrique: string | null }
export interface Diagnostic {
  format: { format: FormatMemoire; motif: string };
  formats: { id: FormatMemoire; libelle: string }[];
  sections: { id: string; numero: number; titre: string; sert_a: string }[];
  devis: { numero: string; revision: number; statut: string; definitif: boolean; lots: { titre: string; postes: number }[] } | null;
  exigences: { total: number; sourcees: number; validees: number };
  pieces: number;
  fiche: { complete: boolean; rubriques: { id: string; titre: string; etat: 'vide' | 'partielle' | 'complete' }[]; alertes: AlerteFiche[] } | null;
  saisie: Record<string, any>;
  modifiable: boolean;
}

export const LIBELLES_FORMAT: Record<FormatMemoire, string> = {
  note: 'Note méthodologique', memoire: 'Mémoire technique', cadre: 'Mémoire selon un cadre imposé',
};
export const AIDES_FORMAT: Record<FormatMemoire, string> = {
  note: 'Petit chantier : 3 à 8 pages, méthode resserrée.',
  memoire: 'Chantier avec architecte ou maître d’œuvre : 15 à 30 pages, réponse au CCTP point par point.',
  cadre: 'Gros chantier ou marché public : les rubriques imposées par l’acheteur priment, limite de pages contrôlée.',
};
export const STATUTS: Record<StatutMemoire, { libelle: string; ton: 'ambre' | 'info' | 'succes' }> = {
  brouillon: { libelle: 'Brouillon', ton: 'ambre' }, relu: { libelle: 'Relu — prêt à émettre', ton: 'info' }, emis: { libelle: 'Émis — figé', ton: 'succes' },
};
export const LIBELLES_SOURCE: Record<string, string> = {
  devis: 'Devis', fiche: 'Fiche entreprise', saisie: 'Saisie du dossier', cahier: 'Document de référence', metier: 'Règle métier', reglementation: 'Réglementation',
};
